<template>
    <h1 class="text-headline-primary">
        <slot />
    </h1>
</template>

<style scoped lang="scss">
$element-TextHeadlinePrimary-color: inherit !default;
$element-TextHeadlinePrimary-font: 800 2rem $font-family !default;
$element-TextHeadlinePrimary-font-tablet: 800 2.5rem $font-family !default;
$element-TextHeadlinePrimary-text-transform: none !default;

.text-headline-primary {
    margin: 0;
    margin-bottom: 1.5rem;
    font: $element-TextHeadlinePrimary-font;
    color: $element-TextHeadlinePrimary-color;
    text-transform: $element-TextHeadlinePrimary-text-transform;
}

@media (min-width: $breakpoint-tablet) {
    .text-headline-primary {
        font: $element-TextHeadlinePrimary-font-tablet;
        outline: none;
    }
}
</style>
